/**
 * User reducer
 */

import { cloneDeep } from "lodash";
import _merge from "lodash/merge";

import * as actionTypes from "../../actions/actionTypes";

const assetReducer = (state = {}, action) => {
  let assets;
  try {
    assets = action.response.entities.assets;
  } catch (error) {
    // That's ok
  }

  switch (action.type) {
    case actionTypes.DELETE_ASSETS_SUCCESS: {
      const { assetIds } = action;
      const newState = cloneDeep(state);
      assetIds.forEach(id => {
        delete newState[id];
      });
      return newState;
    }
    case actionTypes.DELETE_ASSET_ITEMS_SUCCESS: {
      const { uuids } = action;
      const newState = cloneDeep(state);
      uuids.forEach(uuid => {
        newState[uuid].items = undefined;
      });
      return newState;
    }
    case actionTypes.UPDATE_ASSETS_CUSTOM_FIELD_SUCCESS: {
      const newState = cloneDeep(state);
      const assets = action.response.entities.assets;
      action.response.result.assets.forEach(asset => {
        newState[asset.asset].fields = assets[asset.asset].fields;
      });
      return newState;
    }
    default: {
      if (assets) {
        return _merge({}, state, assets);
      }
      return state;
    }
  }
};

export default assetReducer;
